// @ts-check
// "Possíveis duplicatas" na página do registro (doc 10, 13.1): até 5 registros com os mesmos valores em algum grupo
// de duplicateCriteria e o botão que abre a mescla com eles e o registro atual.
import { html } from 'htm/preact';
import { useEffect, useState } from 'preact/hooks';
import { findDuplicateRecords, MAXIMUM_MERGE_RECORDS } from '../../data/parity.js';
import { mutationCounterState } from '../../data/record-store.js';
import { RecordChip } from '../../ui/chip.js';
import { Button } from '../../ui/button.js';
import { Icon } from '../../ui/icon.js';
import { openMergeRecordsPanel } from '../side-panel/side-panel-state.js';
import { t } from '../../i18n/index.js';

const VISIBLE_DUPLICATES = 5;

/**
 * @param {{ objectMetadata: import('../../lib/field-metadata.js').ObjectMetadata, record: any, onMerged?: () => void }} props
 *   onMerged: a mescla pode manter o próprio registro aberto, que precisa ser relido
 */
export function DuplicatesSection({ objectMetadata, record, onMerged }) {
  const [duplicates, setDuplicates] = useState(/** @type {any[]} */ ([]));
  const canMerge = Boolean(objectMetadata.duplicateCriteria?.length) && !record.deletedAt;

  useEffect(() => {
    if (!canMerge) return undefined;
    let isCancelled = false;
    // a busca é só uma sugestão: falhar não atrapalha a página
    findDuplicateRecords(objectMetadata, record.id)
      .then((found) => !isCancelled && setDuplicates(found))
      .catch(() => !isCancelled && setDuplicates([]));
    return () => {
      isCancelled = true;
    };
  }, [objectMetadata.id, record.id, canMerge, mutationCounterState.value]);

  if (!canMerge || duplicates.length === 0) return null;
  return html`<div class="duplicates-section" data-testid="duplicates-section">
    <div class="duplicates-section-header">
      <span class="duplicates-section-title"><${Icon} name="IconUsers" size=${14} />${t('parity.merge.duplicatesTitle', { count: duplicates.length })}</span>
      <${Button} icon="IconArrowMerge" title=${t('parity.merge.short')} size="small" variant="secondary" onClick=${() => openMergeRecordsPanel({
        objectNameSingular: objectMetadata.nameSingular,
        ids: [record.id, ...duplicates.map((duplicate) => duplicate.id)].slice(0, MAXIMUM_MERGE_RECORDS),
        onDone: (/** @type {string} */ mergedRecordId) => mergedRecordId === record.id && onMerged?.(),
      })} />
    </div>
    <div class="duplicates-section-chips">
      ${duplicates.slice(0, VISIBLE_DUPLICATES).map((duplicate) => html`<${RecordChip} key=${duplicate.id} objectMetadata=${objectMetadata} record=${duplicate} />`)}
    </div>
  </div>`;
}
